import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function Problem() {
  const problems = ['Videos de YouTube sin orden ni progresión', 'Apps en inglés que no sirven para Argentina', 'Señas sueltas que no podés armar en frases', 'Gramática visual que nadie te explica claro', 'Te bloqueás frente a una persona sorda', 'Empezás, lo dejás, volvés a empezar'];
  return <section className="bg-lsa-light text-lsa-dark py-16 px-5" data-id="element-242">
      <div className="max-w-xl mx-auto" data-id="element-243">
        <h2 className="text-[28px] font-bold mb-4 leading-tight text-center" data-id="element-244">
          ¿Cuántas veces más vas a quedarte en blanco?
        </h2>

        <p className="text-center text-[16px] mb-8 text-lsa-dark/80 font-medium" data-id="element-245">
          Sin un sistema claro, siempre terminás igual.
        </p>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-black/5 mb-8" data-id="element-246">
          <ul className="space-y-4" data-id="element-247">
            {problems.map((problem, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-start gap-3" data-id="element-248">
                <X className="text-red-500 shrink-0 mt-0.5" size={20} data-id="element-249" />
                <span className="text-[15px] font-medium text-lsa-dark/90" data-id="element-250">
                  {problem}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-lsa-medium text-white p-6 rounded-2xl text-center shadow-lg" data-id="element-251">
          <p className="text-[16px] font-medium leading-relaxed" data-id="element-252">
            No es falta de ganas. Es falta de un sistema. Con LSA Fácil, el
            próximo encuentro puede ser diferente.{' '}
            <span className="text-xl align-middle ml-1" data-id="element-253">🤟</span>
          </p>
        </motion.div>
      </div>
    </section>;
}